export default __webpack_public_path__ + "static/media/Skirmisher's War Fist.eeba89d2.jpg";